import React, { FC, Fragment, useState, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import MissedTransportOrders from 'pages/transport-admin/missed-transport-orders/missed-transport-orders.component';
import { Box, Button, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { useNavigate, useParams } from 'react-router-dom';
import TransportOrders from 'pages/transport-admin/transport-orders/transport-orders.component';

const TransportAdmin: FC = () => {
    const { t: translate } = useTranslation(['transport']);
    const { tab } = useParams<{ tab: string }>();
    const [tabState, setTabState] = useState(tab || '');
    const navigate = useNavigate();

    const handleTabChange = (_: unknown, newTabState: string) => {
        if (tabState !== newTabState) {
            navigate(`/admin-transport/${newTabState}`);
            setTabState(newTabState);
        }
    };

    return (
        <Fragment>
            <TabContext value={tabState}>
                <Box mb={2} display="flex" alignItems="center" flexWrap="wrap">
                    <Box flex="1 0 auto">
                        <TabList onChange={handleTabChange} indicatorColor="primary" textColor="primary">
                            <Tab label={translate('transport:TRANSPORT_ORDERS')} value="transport-orders" />
                            <Tab label={translate('transport:MISSED_TRANSPORT_ORDERS')} value="missed-transport" />
                        </TabList>
                    </Box>
                    <Box flex="0 0 auto">
                        <Button
                            sx={{ marginRight: 1 }}
                            variant="contained"
                            onClick={() => navigate('/admin-add-transport/pickup')}
                        >
                            {translate('transport:PICKUP_FROM_CLINIC')}
                        </Button>
                        <Button variant="contained" onClick={() => navigate('/admin-add-transport/delivery')}>
                            {translate('NEW_DELIVERY')}
                        </Button>
                    </Box>
                </Box>
                <TabPanel style={{ padding: 0 }} value="transport-orders">
                    <Suspense fallback={null}>
                        <TransportOrders />
                    </Suspense>
                </TabPanel>
                <TabPanel style={{ padding: 0 }} value="missed-transport">
                    <Suspense fallback={null}>
                        <MissedTransportOrders />
                    </Suspense>
                </TabPanel>
            </TabContext>
        </Fragment>
    );
};

export default TransportAdmin;
